import { type ReactNode } from 'react';
import { isDesktop, usePlatform } from '../lib/client-platform';
import { DesktopCaptures } from './desktop-captures';

export function DesktopFrame({ children }: { children: ReactNode }) {
  const state = usePlatform();
  if (!isDesktop()) return children;
  return (
    <div className="desktop-frame">
      <div
        className="desktop-content"
        key={`${state?.apiOrigin}:${state?.user?.id || 'signed-out'}`}
      >
        {children}
        <DesktopCaptures />
      </div>
    </div>
  );
}
